import cx from "classnames";
import React, { memo } from "react";
import { Tooltip } from "@smartsuite/react-ui/lib/components/help/Tooltip/Tooltip";
import { Icon } from "@smartsuite/react-ui/lib/components/utils/Icon/Icon";
const EditorToolbarButtonRaw = ({ icon, iconSize = "M", title, active, color, light = false, kind = "normal", disabled = false, disableTooltip = false, className: classNameProp = "", tooltipClassName = "", children, ...rest }) => {
    const className = cx("editor-toolbar-button", `editor-toolbar-button--color-${color}`, `editor-toolbar-button--kind-${kind}`, {
        "editor-toolbar-button--active": active,
        "editor-toolbar-button--light": light,
        "editor-toolbar-button--disabled": disabled,
    }, classNameProp);
    return (React.createElement(Tooltip, { placements: ["top", "bottom"], className: cx("editor-toolbar-button-tooltip", tooltipClassName), text: !disabled && title, padding: 2, disabled: disableTooltip, target: React.createElement("button", { className: className, "aria-label": title, "aria-pressed": active, type: "button", disabled: disabled, tabIndex: -1, ...rest },
            React.createElement(Icon, { name: icon, size: iconSize }),
            children) }));
};
export const EditorToolbarButton = memo(EditorToolbarButtonRaw);
